export const FETCH_ALL_USERS_REQUEST = "FETCH_ALL_USERS_REQUEST";
export const FETCH_ALL_USERS_SUCCESS = "FETCH_ALL_USERS_SUCCESS";
export const FETCH_ALL_USERS_FAILURE = "FETCH_ALL_USERS_FAILURE";
